// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-redirector',
    templateUrl: './redirector.component.html',
    styleUrls: ['./redirector.component.scss'],
    standalone: false
})
export class RedirectorComponent implements OnInit {

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      localStorage['token'] = params.token;
      window.location = params.redirect;
    });
    this.changeDetectorRef.detectChanges();
  }
}
